import { motion } from "framer-motion";
import Block3Columns from "../../components/Block3Columns";
import FixedHeader from "../../components/FixedHeader";
import DataFetcherTemplate from "../../hooks/fetchTemplate";
import ModalFixed from "../../components/ModalFixed";
import BannerGeneral from "../../components/BannerGeneral";
import ImageGallery from "../../components/ImageGallery";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import Block4ColumnsText from "../../components/Block4ColumnsText";

function Internacional() {
  const DataDisplay = ({ data }) => (
    <>
      {data.map((item, index) => (
        <>
          <BlockImageCabecera
            src={item.field_portada}
            title={
              <div
                dangerouslySetInnerHTML={{
                  __html: item.field_texto_portada,
                }}
              />
            }
          ></BlockImageCabecera>

          <div className="padding graybg">
            <center>
              <div
                className="width700"
                dangerouslySetInnerHTML={{
                  __html: item.field_bloque1,
                }}
              />
            </center>
            <div className="margin">
              <Block4ColumnsText
                col1={
                  <>
                    <img src={item.field_imagen2} alt="utpl"></img>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque2,
                      }}
                    />
                  </>
                }
                col2={
                  <>
                    <img src={item.field_imagen3} alt="utpl"></img>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque3,
                      }}
                    />
                  </>
                }
                col3={
                  <>
                    <img src={item.field_imagen4} alt="utpl"></img>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque4,
                      }}
                    />
                  </>
                }
                col4={
                  <>
                    <img src={item.field_imagen5} alt="utpl"></img>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque5,
                      }}
                    />
                  </>
                }
              ></Block4ColumnsText>
            </div>
          </div>

          <div className="padding">
            <div>
              <div className="layout8">
                <center>
                  <div
                    className="width700"
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque6
                    }}
                  />
                </center>
              </div>
              <Block3Columns
                col1={   <>
                    <img src={item.field_imagen7} alt="utpl"></img>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque7
                      }}
                    />
                  </>}
                col2={   <>
                    <img src={item.field_imagen8} alt="utpl"></img>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque8
                      }}
                    />
                  </>}
                col3={   <>
                    <img src={item.field_imagen9} alt="utpl"></img>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque8
                      }}
                    />
                  </>}
              ></Block3Columns>
            </div>
          </div>
        </>
      ))}
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/services/servicio-internacional.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>

      <div className="padding">
        <center>
          <h2>¿Necesitas ayuda?</h2>
          <h2 className="tag3-retoma">
            {" "}
            Un asesor está listo para ayudarte. Conéctate con nosotros en{" "}
            <a target="_blank" rel="noreferrer" href="https://utpl.edu.ec/zoom">
              <b>utpl.edu.ec/zoom 📹</b>
            </a>
          </h2>
        </center>
      </div>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default Internacional;
